import { Alert, Button, Col, Form, Input, Modal, Row, Table, Tooltip } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';

function Vendor() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');

    const titlePage = 'Vendor Data';

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            width: 70,
            render: (id, record, index) => {
                ++index;
                return (page.pagination.current - 1) * page.pagination.pageSize + index;
            },
        },
        {
            title: 'Vendor Code',
            dataIndex: 'vendor_code',
            key: 'vendor_code',
            render: (text) => text || '-',
        },
        {
            title: 'Vendor Name',
            dataIndex: 'vendor_name',
            key: 'vendor_name',
            render: (text) => text || '-',
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
            render: (text) => text || '-',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (text) => text || '-',
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            render: (text) => text || '-',
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            render: (text) => text || '-',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 150,
            render: (text, record) => (
                <>
                    <Tooltip title="Edit">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => openModal('edit', record)}
                        >
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button
                            type="primary"
                            danger
                            onClick={() => modalDeleteData(record)}
                        >
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </>
            ),
        },
    ];

    useEffect(() => {
        getApi(
            'GET',
            `/vendors?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}`
        );
    }, [search, page.pagination.current, page.pagination.pageSize, isAlert]);

    const getApi = (method, url) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        };

        apiCall(dataReq)
            .then((res) => {
                if (res.status === 'success') {
                    setData(res.data.data || []);
                    setPage((prev) => ({
                        ...prev,
                        pagination: {
                            ...prev.pagination,
                            total: res.data.total_data || 0,
                        },
                    }));
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.log(e.message);
            });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);

        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        };

        await apiCall(dataReq)
            .then((res) => {
                if (res.status === 'success') {
                    setDataModal(null);
                    setIsModal(false);
                    setIsAlert(true);
                    setTextAlert(res.message);
                    form.resetFields();
                } else {
                    modalError(res.message);
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.log(e.message);
            });
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this data?',
            onOk: () => postApi('DELETE', '/vendors/' + v.vendor_id, null),
        });
    };

    const openModal = (type, data) => {
        if (type === 'edit' && data) {
            setDataModal(data);
            form.setFieldsValue({
                vendor_code: data.vendor_code,
                vendor_name: data.vendor_name,
                phone: data.phone,
                email: data.email,
                address: data.address,
                notes: data.notes,
            });
        } else {
            setDataModal(null);
            form.resetFields();
        }
        setIsModal(true);
    };

    const onFinish = (ev) => {
        if (dataModal) {
            postApi('PUT', '/vendors/' + dataModal.vendor_id, ev);
        } else {
            postApi('POST', '/vendors', ev);
        }
    };

    const closeModal = () => {
        setDataModal(null);
        setIsModal(false);
        form.resetFields();
    };

    const handleTableChange = (pagination) => {
        setPage({
            pagination,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
        });
    };

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                />
            )}

            <h3>Vendor Data</h3>

            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search vendor"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        style={{ marginBottom: 10 }}
                        type="primary"
                        onClick={() => openModal('add', null)}
                    >
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>

            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey={(record) => record.vendor_id}
                scroll={{ x: 1200 }}
            />

            <Modal
                title="Vendor Data"
                open={isModal}
                onOk={form.submit}
                onCancel={closeModal}
                okText="Save"
            >
                <Form form={form} name="form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="vendor_code"
                        label="Vendor Code"
                        rules={[{ required: true, message: 'Vendor Code is required!' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="vendor_name"
                        label="Vendor Name"
                        rules={[{ required: true, message: 'Vendor Name is required!' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="phone"
                                label="Phone"
                                rules={[{ required: false }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="email"
                                label="Email"
                                rules={[{ required: false, type: 'email', message: 'Email is not valid!' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item
                        name="address"
                        label="Address"
                        rules={[{ required: false }]}
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>

                    <Form.Item
                        name="notes"
                        label="Notes"
                        rules={[{ required: false }]}
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default Vendor;